import { memoize } from 'lodash';

import { Constants } from '@types';
import { getEnv } from '@config/env';
import packageJson from '../../../package.json';

const MAINNET_ADDRESSES = {
  ETH: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  LOOT_PORTAL: '0xa5e24bb4B7Fd816583A5C6aD30807Cc202A416B4',
  DEEVY: '0x8F4cBC81589Ba28B67C371EaB3d696Ad67B25c24',
};

const TESTNET_ADDRESSES = {
  ...MAINNET_ADDRESSES,
  LOOT_PORTAL: '0x3cAefeE592c5470B74B2408AB830eCCEf61c5811',
};

export const getConstants = memoize((): Constants => {
  const { INFURA_PROJECT_ID, NETWORK } = getEnv();
  const arbitrumNetwork = NETWORK === 'mainnet' ? 'arb1' : NETWORK;
  const addresses =
    NETWORK === 'mainnet' ? MAINNET_ADDRESSES : TESTNET_ADDRESSES;
  return {
    APP_NAME: packageJson.name ?? 'myApp',
    APP_URL: 'https://myapp',
    APP_EMAIL: 'myapp@myapp.com',
    STATE_VERSION: 1,
    MAX_UINT256:
      '115792089237316195423570985008687907853269984665640564039457584007913129639935',
    DEFAULT_PROVIDER_TYPE: 'ethereum',
    ETHEREUM_PROVIDER: `https://${NETWORK}.infura.io/v3/${INFURA_PROJECT_ID}`,
    ARBITRUM_PROVIDER: `https://${arbitrumNetwork}.arbitrum.io/rpc`,
    FANTOM_PROVIDER: 'https://rpc.ftm.tools',
    CONTRACT_ADDRESSES: {
      ...addresses,
    },
  };
});
